__turbopack_context__.v({
  "icon": "rights-restricted-message-module-scss-module__Avx_dq__icon",
  "message": "rights-restricted-message-module-scss-module__Avx_dq__message",
});
